<template>
    <div class="gallery-message">
        <div class="cards" ref="cardContainer">
            <div class="prev" @click="prevCard" v-if="currentIndex !== 0">
                <md-button class="md-icon-button">
                    <md-icon>chevron_left</md-icon>
                </md-button>
            </div>
            <GalleryImageCard
                v-for="(card, index) in items"
                :key="'card-' + index"
                :card="card"
                ref="cardRefs"
                :current="index === currentIndex"
                :block-id="data.blockId"
                :payload-id="data.id"
                :conversation-id="conversationId"
                :is-selected="$_.get(lastClickedButton, 'cardId') === card.id"
                :selected-button-id="$_.get(lastClickedButton, 'buttonId')"
            />
            <div class="next">
                <md-button class="md-icon-button" @click="nextCard" v-if="currentIndex !== items.length - 1">
                    <md-icon>chevron_right</md-icon>
                </md-button>
            </div>
        </div>
    </div>
</template>

<script>
import GalleryImageCard from "./GalleryImageCard";

export default {
    name: "BotGalleryMessage",
    components: { GalleryImageCard },
    props: {
        data: {
            type: Object,
            required: true,
            default: () => ({
                cards: [],
                id: "",
                blockId: "",
                cardId: "",
            }),
        },
        lastClickedButton: {
            type: Object,
            required: null,
        },
        conversationId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            items: this.data.cards,
            currentIndex: 0,
        };
    },
    methods: {
        scrollToCard() {
            const isLast = this.currentIndex === this.items.length - 1;
            this.$refs.cardContainer.scroll(240 * this.currentIndex - (isLast ? 0 : 80), 0);
        },
        nextCard() {
            if (this.currentIndex < this.items.length - 1) {
                this.currentIndex++;
                this.scrollToCard();
            }
        },
        prevCard() {
            if (this.currentIndex > 0) {
                this.currentIndex--;
                this.scrollToCard();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.gallery-message {
    overflow-x: auto;

    .cards {
        display: flex;
        flex-wrap: nowrap;
        gap: 20px;
        overflow: hidden;
        width: 100%;
        scroll-behavior: smooth;
        //border: 1px solid red;

        .prev,
        .next {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 40px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            .md-button {
                background: white;
                box-shadow: 0 0 15px 0 rgb(0 0 0 / 50%);

                .md-icon {
                    font-size: 35px !important;
                    color: #448aff;
                }
            }

            //border: 1px solid green;
        }

        .prev {
            left: 0;
        }

        .next {
            right: 0;
        }
    }

    .controls {
        border: 1px solid green;
    }
}
</style>
